var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "marketing-dialog-config" },
    [
      _c("div", { staticClass: "title" }, [_vm._v("营销弹窗配置：")]),
      _c(
        "el-form",
        {
          ref: "form",
          staticClass: "config-form",
          attrs: { model: _vm.form, rules: _vm.rules, "label-width": "150px" },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "主弹窗图", prop: "mainPicture" } },
            [
              _c("imageUpload", {
                attrs: {
                  imageList: _vm.form.mainPicture
                    ? [{ url: _vm.form.mainPicture }]
                    : [],
                  limit: 1,
                  fileSize: 1,
                  isShowTip: true,
                  WHtip: true,
                  width: 640,
                  height: 720,
                  fileType: ["png", "jpg"],
                  accept: ".jpg,.png",
                  multiple: false,
                  code: "advertising",
                },
                on: {
                  input: function (val) {
                    _vm.getImg(val, "mainPicture")
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "活动规则", prop: "activityRule" } },
            [
              _c("RichTextEditor", {
                staticStyle: { width: "415px" },
                model: {
                  value: _vm.form.activityRule,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "activityRule", $$v)
                  },
                  expression: "form.activityRule",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }